module.exports = __webpack_public_path__ + "static/media/2.8a1b9409.jpg";